import { jsxs as l, jsx as C } from "react/jsx-runtime";
const h = ({
  width: i,
  height: r,
  className: t
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 20 20",
    width: i,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_15632_25978)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17.1485 11.6159C17.1074 13.02 15.9295 14.1416 14.5383 14.2736L6.74684 14.2838L4.01868 17.0018C3.58572 17.3058 3.05926 17.0801 2.90085 16.6023L2.88179 14.2742C1.42391 14.282 0.184 13.1514 0.0345195 11.6983C0.0345195 10.8526 0.0333285 10.0075 0.0333285 9.16179C0.0327329 7.64597 0.0315418 6.12957 0.0309463 4.61375C0.0303508 3.50706 -0.170942 2.31674 0.465095 1.33606C0.978449 0.542323 1.87712 0.0483998 2.81807 0.0251072H2.84725C5.41164 -0.0143111 7.97604 2.28443e-05 10.5404 0.019732C11.3968 0.0263017 12.2532 0.0328714 13.1102 0.0370521C13.5485 0.0394411 13.9868 0.0406356 14.4257 0.0418301C14.8914 0.0424274 15.3458 0.0298852 15.7693 0.253853C16.1593 0.459903 16.4863 0.788986 16.7031 1.17242C17.1057 1.88493 17.1336 2.66613 17.1158 3.46166M4.30811 14.6762C4.56002 14.4265 4.81194 14.1775 5.06385 13.9278C5.41164 13.5838 5.71597 13.1108 6.17751 12.9077C6.33235 12.8396 6.48481 12.854 6.65037 12.8534L8.0743 12.8516C9.44464 12.8498 10.815 12.8486 12.1859 12.8468C12.9035 12.8462 13.6462 12.9011 14.3626 12.8444C15.1166 12.7847 15.6627 12.237 15.7222 11.4809C15.7222 8.67145 15.7002 5.65655 15.7222 2.8041C15.7282 2.02708 15.1743 1.49493 14.4043 1.39877C10.4291 1.43521 6.43657 1.32173 2.47147 1.45611C1.87533 1.64424 1.50252 2.13697 1.45369 2.7599C1.39235 5.64042 1.35423 8.65592 1.45369 11.4367C1.47989 12.1719 1.98253 12.7554 2.73053 12.8372C3.16884 12.885 3.77987 12.7506 4.14612 13.0624C4.37243 13.2547 4.31287 13.5265 4.30871 13.7899C4.30394 14.0849 4.30871 14.3805 4.30871 14.6762H4.30811Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M15.7204 16.2637C15.8437 15.5201 16.7966 15.7536 17.2974 15.6993C17.7363 15.6515 18.1824 15.3732 18.398 14.9838C18.6558 14.5185 18.5445 13.8072 18.5546 13.2941C18.5826 11.9372 18.585 10.5797 18.5808 9.22271C18.5742 7.30794 18.554 5.39257 18.5731 3.47779C18.6951 2.61238 19.8779 2.61238 20 3.47779L19.994 14.5591C19.8404 16.0062 18.6082 17.1482 17.1467 17.135C17.089 17.8368 17.2254 18.6616 17.1467 19.3484C17.0866 19.8764 16.4899 20.181 16.0343 19.883L13.2817 17.1446L7.05354 17.1315C6.2442 16.9714 6.2442 15.8689 7.05354 15.7088C8.0058 15.7088 8.95867 15.7088 9.91093 15.7088C11.1151 15.7088 12.3378 15.6473 13.5407 15.707C14.1047 15.7351 14.5204 16.3491 14.8938 16.7188C15.1695 16.9917 15.4447 17.2646 15.7204 17.5376C15.7657 17.1512 15.6597 16.6322 15.7204 16.2637Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.67417 7.83649C6.50095 7.68957 6.3217 6.42162 6.45986 5.45646C6.55574 4.78815 7.19773 4.24704 7.87248 4.25779C7.92787 3.30757 9.24758 3.30638 9.30297 4.25779C9.86337 4.2339 10.7126 4.17238 10.7311 4.95299C10.7382 5.23668 10.4625 5.69059 10.1701 5.69059H7.87427V6.40609H9.50128C10.1427 6.40609 10.6822 7.17474 10.7287 7.76781C10.8168 8.88884 10.5935 9.88087 9.30416 9.98598C9.24401 10.935 7.92846 10.9362 7.87248 9.98419C7.31208 10.0081 6.46284 10.0696 6.44438 9.289C6.43723 9.0053 6.71296 8.5514 7.00537 8.5514H9.30118V7.8359C8.78901 7.78931 8.17323 7.89861 7.67417 7.8359V7.83649Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_15632_25978", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "white",
          height: "20",
          width: "20"
        }
      ) }) })
    ]
  }
);
export {
  h as Content
};
